import React, { Component } from 'react'
import { connect } from 'react-redux'
import debounce from 'lodash/debounce'
import DetailsRow from './DetailsRow'
import { getProfileData, getSortDirection, getSortColumn, getDocumentForm, getSearchBoxText, getAsOfDate, getInitialLoad, getActivePane } from '../../../reducers/data'
import { setSort, setSortDetails, toggleDocumentForm, setFilterWord, loadFundDataExcel, setActivePane } from '../../../actions/data'
import './DetailsTable.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faFileExcel, faAngleDown, faAngleUp, faMinusCircle, faDownload } from '@fortawesome/free-solid-svg-icons'
import i18n from '../../../i18n'
library.add(faCircleNotch, faFileExcel, faAngleDown, faAngleUp, faMinusCircle, faDownload)

class DetailsTable extends Component {
  constructor(props) {
    super(props)
    this.state = { init: '', searchText: '' }
    this.onInputChange = this.onInputChange.bind(this)

    this.debouncedCallback = debounce(
      // function
      value => {
        this.props.setFilterWord(value)
      },
      // delay in ms
      1000
    )
  }

  onInputChange(event) {
    const m = event.target.value
    this.text = event.target.value

    this.setState({ init: m, searchText: m })
    this.debouncedCallback(m)
  }

  onInputChange2(event) {
    this.text = event.target.value
    this.setState({ init: this.text })
    this.props.setFilterWord(this.text)
  }

  setSortData(column) {
    this.props.setSort(column)
  }

  setSortDataDetails(column, type) {
    this.props.setSortDetails(column, type)
  }

  toggleDocumentDetails(param) {
    this.props.toggleDocumentForm()
  }

  // create the rows
  renderRows() {
    const { data } = this.props

    if (data.length === 0 && this.props.intialLoad === 'false') {
      return (
        <tr>
          <td colSpan='11' style={{ textAlign: 'center' }}>
            <FontAwesomeIcon icon='circle-notch' size='3x' style={{ color: '#05A9B1' }} spin />
          </td>
        </tr>
      )
    } else {
      return data.map(fund => {
        return <DetailsRow key={fund.bloombergTicker} fund={fund} wtregion={this.props.region} division={this.props.division} lang={this.props.lang} isLeveraged={this.props.isLeveraged} isFP={this.props.isFP} isEU={this.props.isEU} />
      })
    }
  }

  renderDocRows() {
    const { data } = this.props

    if (data.length === 0 && this.props.intialLoad === 'false') {
      return (
        <tr>
          <td colSpan='11' style={{ textAlign: 'center' }}>
            <FontAwesomeIcon icon='circle-notch' size='3x' style={{ color: '#05A9B1' }} spin />
          </td>
        </tr>
      )
    } else {
      return data.map(fund => {
        return <DetailsRow key={fund.bloombergTicker} fund={fund} wtregion={this.props.region} division={this.props.division} lang={this.props.lang} isLeveraged={this.props.isLeveraged} isFP={this.props.isFP} isEU={this.props.isEU} />
      })
    }
  }
  getExcelDownload = () => {
    this.props.loadFundDataExcel()
  }

  formatDate(string) {
    return new Date(string).toLocaleDateString([], { timeZone: 'UTC' })
  }

  asOfDate() {
    if (this.props.asOfDate) {
      return `${i18n.t('Asof')} ${this.formatDate(this.props.asOfDate)}`
    } else {
      return ''
    }
  }

  setTblHeadClass(type) {
    if (type === this.props.sortColumn && this.props.sortDirection === 'DESC') {
      return 'des'
    } else if (type === this.props.sortColumn && this.props.sortDirection === 'ASC') {
      return 'asc'
    } else {
      return ''
    }
  }

  setSortIcon(type) {
    if (type === this.props.sortColumn && this.props.sortDirection === 'DESC') {
      return <FontAwesomeIcon icon='angle-down' size='sm' />
    } else if (type === this.props.sortColumn && this.props.sortDirection === 'ASC') {
      return <FontAwesomeIcon icon='angle-up' size='sm' />
    } else {
      return ' '
    }
  }
  setActivePanel(val) {
    this.props.setActivePane(val)
  }

  buttonFundCcyClass(value) {
    return value === this.props.activePane ? 'navButton' + ' ' + 'isselected' : 'navButton' + ' ' + 'notselected'
  }

  renderHeader() {
    if (!this.props.isEU) {
      return (
        <thead>
          <tr>
            <th className={'fundlistheadtix'} onClick={() => this.setSortDataDetails('displayName', 'text')}>
              <div style={{ display: 'inline-block' }}>{i18n.t('WisdomTree Fund')}</div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('displayName')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('bloombergTicker', 'text')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Fund')}
                <br />
                {i18n.t('Ticker')}
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('bloombergTicker')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('fundCategoryTier1', 'text')}>
              <div style={{ display: 'inline-block' }}>
                Asset
                <br />
                Class
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('fundCategoryTier1')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('fundCategoryTier2', 'text')}>
              <div style={{ display: 'inline-block' }}>
                Sub-Asset
                <br />
                Class
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('fundCategoryTier2')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('inceptionDt', 'text')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Inception')}
                <br />
                {i18n.t('Date')}
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('inceptionDt')}</div>
            </th>
            {/* <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('SharesOutstanding', 'numeric')}><div style={{ display: 'inline-block' }}>{i18n.t('Shares')}<br />{i18n.t('Outstanding')}</div><div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('SharesOutstanding')}</div></th> */}
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('grossExpenseRatio', 'numeric')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('grossexpense')}
                <br />
                {i18n.t('Ratio')}
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('grossExpenseRatio')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('expenseRatio', 'numeric')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('netexpense')}
                <br />
                {i18n.t('Ratio')}
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('expenseRatio')}</div>
            </th>
            {/* <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('NAV', 'numeric')}><div style={{ display: 'inline-block' }}>{i18n.t('NAV')}</div><div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('NAV')}</div></th> */}
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('AUM', 'numeric')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Assets Under')}
                <br />
                {i18n.t('thousands')}
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('AUM')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('YIELD', 'numeric')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Trailing')}
                <br />
                {i18n.t('Yield')}
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('YIELD')}</div>
            </th>
            {this.props.division === '1' && (
              <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('volume', 'numeric')}>
                <div style={{ display: 'inline-block' }}>{i18n.t('volume')}</div>
                <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('volume')}</div>
              </th>
            )}
          </tr>
        </thead>
      )
    } else if (this.props.isEU && this.props.isLeveraged === '-1') {
      return (
        <thead>
          <tr>
            <th className={'fundlistheadtix'} onClick={() => this.setSortDataDetails('displayName', 'text')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Product')} {this.setSortIcon('displayName')}
              </div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('bloombergTicker', 'text')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Ticker')} {this.setSortIcon('bloombergTicker')}
              </div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('leverageFactor', 'text')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Leverage')}
                <br />
                {i18n.t('Factor')} {this.setSortIcon('leverageFactor')}
              </div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('expenseRatio', 'numeric')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('MER')} {this.setSortIcon('expenseRatio')}
              </div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('baseCCY', 'text')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Base')}
                <br />
                {i18n.t('Currency')} {this.setSortIcon('baseCCY')}
              </div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('listingCCY', 'text')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Trading')}
                <br />
                {i18n.t('Currency')} {this.setSortIcon('listingCCY')}
              </div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('useOfIncome', 'text')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('UseOf')}
                <br />
                {i18n.t('Income')} {this.setSortIcon('useOfIncome')}
              </div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('NAV', 'numeric')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Price')} {this.setSortIcon('NAV')}
              </div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('dailyChange', 'numeric')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Daily')}
                <br />
                {i18n.t('Change')} {this.setSortIcon('dailyChange')}
              </div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('AUM', 'numeric')}>
              <div style={{ textAlign: 'center', display: 'inline-block' }}>
                {i18n.t('AUM')} {this.setSortIcon('AUM')}
              </div>
            </th>
          </tr>
        </thead>
      )
    } else if (this.props.isEU && this.props.isLeveraged === '1') {
      return (
        <thead>
          <tr>
            <th className={'fundlistheadtix'} onClick={() => this.setSortDataDetails('displayName', 'text')}>
              <div style={{ display: 'inline-block' }}>{i18n.t('Product')}</div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('displayName')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('bloombergTicker', 'text')}>
              <div style={{ display: 'inline-block' }}>{i18n.t('Ticker')}</div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('bloombergTicker')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('leverageFactor', 'text')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Leverage')}
                <br />
                {i18n.t('Factor')}
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('useOfIncome')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('expenseRatio', 'numeric')}>
              <div style={{ display: 'inline-block' }}>{i18n.t('MER')}</div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('expenseRatio')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('baseCCY', 'text')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Base')}
                <br />
                {i18n.t('Currency')}
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('baseCCY')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('listingCCY', 'text')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Trading')}
                <br />
                {i18n.t('Currency')}
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('listingCCY')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('NAV', 'numeric')}>
              <div style={{ display: 'inline-block' }}>{i18n.t('Price')}</div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('NAV')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('dailyChange', 'numeric')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Daily')}
                <br />
                {i18n.t('Change')}
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('dailyChange')}</div>
            </th>
          </tr>
        </thead>
      )
    } else if (this.props.isEU && this.props.isLeveraged === '0') {
      return (
        <thead>
          <tr>
            <th className={'fundlistheadtix'} onClick={() => this.setSortDataDetails('displayName', 'text')}>
              <div style={{ display: 'inline-block' }}>{i18n.t('Product')}</div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('displayName')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('bloombergTicker', 'text')}>
              <div style={{ display: 'inline-block' }}>{i18n.t('Ticker')}</div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('bloombergTicker')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('expenseRatio', 'numeric')}>
              <div style={{ display: 'inline-block' }}>{i18n.t('MER')}</div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('expenseRatio')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('baseCCY', 'text')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Base')}
                <br />
                {i18n.t('Currency')}
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('baseCCY')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('listingCCY', 'text')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Trading')}
                <br />
                {i18n.t('Currency')}
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('listingCCY')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('NAV', 'numeric')}>
              <div style={{ display: 'inline-block' }}>{i18n.t('NAV')}</div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('NAV')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('useOfIncome', 'text')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('UseOf')}
                <br />
                {i18n.t('Income')}
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('useOfIncome')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('AUM', 'numeric')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('AUM')}
                <br />
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('AUM')}</div>
            </th>
          </tr>
        </thead>
      )
    } else {
      return null
    }
  }

  renderDocHeader() {
    if (!this.props.isEU) {
      return (
        <thead>
          <tr>
            <th className={'fundlistheadtix'} onClick={() => this.setSortDataDetails('displayName', 'text')}>
              <div style={{ display: 'inline-block' }}>{i18n.t('WisdomTree Fund')}</div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('displayName')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('bloombergTicker', 'text')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Fund')}
                <br />
                {i18n.t('Ticker')}
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('bloombergTicker')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('SharesOutstanding', 'numeric')}>
              <div style={{ display: 'inline-block' }}>
                {i18n.t('Shares')}
                <br />
                {i18n.t('Outstanding')}
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('SharesOutstanding')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('NAV', 'numeric')}>
              <div style={{ display: 'inline-block' }}>{i18n.t('NAV')}</div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('NAV')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('relatedIndex', 'text')}>
              <div style={{ textAlign: 'center', display: 'inline-block' }}>
                Related
                <br />
                Index
              </div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('relatedIndex')}</div>
            </th>
            <th className={'fundlistheadreg'}>
              <div style={{ display: 'inline-block', paddingRight: '15px' }}>{i18n.t('Factsheet')}</div>
            </th>
            <th className={'fundlistheadreg'}>
              <div style={{ display: 'inline-block', paddingRight: '80px' }}>{i18n.t('Prospectus')}</div>{' '}
            </th>
            <th className={'fundlisthead'}>
              <div style={{ textAlign: 'left', display: 'inline-block' }}>Notes</div>
              <div style={{ display: 'inline-block', paddingRight: '80px' }}></div>
            </th>
          </tr>
        </thead>
      )
    } else if (this.props.isEU) {
      return (
        <thead>
          <tr>
            <th className={'fundlistheadtix'} onClick={() => this.setSortDataDetails('displayName', 'text')}>
              <div style={{ display: 'inline-block' }}>{i18n.t('Product')}</div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('displayName')}</div>
            </th>
            <th className={'fundlisthead'} onClick={() => this.setSortDataDetails('bloombergTicker', 'text')}>
              <div style={{ display: 'inline-block' }}>{i18n.t('Ticker')}</div>
              <div style={{ display: 'inline-block', paddingLeft: '3px' }}>{this.setSortIcon('bloombergTicker')}</div>
            </th>
            {/* REMOVING TEMPORARYILY FOR EU FACTSHEETS */}
            {/* <th className={'fundlistheadreg'}> <div style={{ display: 'inline-block', paddingRight: '15px' }}  >{i18n.t('Factsheet')}</div></th> */}
            <th className={'fundlistheadreg'}>
              <div style={{ display: 'inline-block', paddingRight: '15px' }}>{i18n.t('Prospectus')}</div>
            </th>
            <th className={'fundlistheadreg'}>
              <div style={{ display: 'inline-block', paddingRight: '70px' }}>{i18n.t('kid')}</div>
            </th>
          </tr>
        </thead>
      )
    } else {
      return null
    }
  }

  renderButtons() {
    const Ico = 'download'
    return (
      <div className={'row ' + 'listoptions'}>
        <button onClick={() => this.setActivePanel('fund')} type='button' className={this.buttonFundCcyClass('fund')}>
          {i18n.t('funds')}
        </button>

        <button onClick={() => this.setActivePanel('document')} type='button' className={this.buttonFundCcyClass('document')}>
          {i18n.t('documents')}
        </button>

        <span style={{ fontWeight: 'bold', paddingLeft: '10px', color: '#5b6770', fontSize: '14px' }}> {this.asOfDate()}</span>
        <span className={'downloadExcelIcon'}>
          {this.props.intialLoad && (
            <div width='100' className={'downloadExcelIcon'} onClick={this.getExcelDownload}>
              {' '}
              {i18n.t('DownloadData')} <FontAwesomeIcon icon={Ico} />
            </div>
          )}
        </span>
      </div>
    )
  }

  render() {
    function placeholderText(props, type) {
      let placeholder = ''
      if (type === 'SEARCH') {
        placeholder = i18n.t('SEARCH')
      }
      return placeholder
    }

    return (
      <div>
        <form onSubmit={this.onFormSubmit} className='input-group'>
          <input style={{ height: '35px' }} className='form-control' placeholder={placeholderText(this.props, 'SEARCH')} onChange={this.onInputChange} value={this.props.searchText} />
        </form>

        <div className='row'>
          <br /> <br />
          <div className='col-sm-12' role='group'>
            <div>{this.renderButtons()}</div>
          </div>
        </div>

        <div className='table-responsive'>
          {this.props.activePane === 'fund' && (
            <table className={'table tableFC '} style={{ marginTop: '0px' }}>
              {this.renderHeader()}
              <tbody>{this.renderRows()}</tbody>
            </table>
          )}

          {this.props.activePane === 'document' && (
            <table className={'table tableFC'} style={{ marginTop: '0px' }}>
              {this.renderDocHeader()}
              <tbody>{this.renderDocRows()}</tbody>
            </table>
          )}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    data: getProfileData(state),
    sortDirection: getSortDirection(state),
    sortColumn: getSortColumn(state),
    showDocform: getDocumentForm(state),
    showBoxText: getSearchBoxText(state),
    asOfDate: getAsOfDate(state),
    intialLoad: getInitialLoad(state),
    activePane: getActivePane(state)
  }
}

export default connect(mapStateToProps, {
  setSort,
  setSortDetails,
  setActivePane,
  toggleDocumentForm,
  setFilterWord,
  loadFundDataExcel
})(DetailsTable)



// WEBPACK FOOTER //
// ./src/components/App/DetailsTable/DetailsTable.js